export default {
  id: null,
  description: null,
  insuranceID: null,
  businessTypeID: null,
  budgetSystemID: null,
  companyID: null,
  schedulingTypeID: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/regulation/imports/importregulationautomodel.js